/**
 * @generated SignedSource<<7afb542861f282254beed5cdea23e34c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type modelGeneration3DModelsQuery$variables = Record<PropertyKey, never>;
export type modelGeneration3DModelsQuery$data = {
  readonly modelGeneration3DModels: ReadonlyArray<{
    readonly maxPromptLength: number;
    readonly model: string;
    readonly serviceID: number;
    readonly serviceIDs: ReadonlyArray<number>;
    readonly supportedModes: ReadonlyArray<string>;
    readonly supportedParameters: ReadonlyArray<{
      readonly allowedValues: ReadonlyArray<string>;
      readonly defaultValue: string | null;
      readonly isRequired: boolean;
      readonly maxValue: number | null;
      readonly minValue: number | null;
      readonly name: string;
      readonly supportedModes: ReadonlyArray<string>;
      readonly type: string;
    }>;
  }>;
};
export type modelGeneration3DModelsQuery = {
  response: modelGeneration3DModelsQuery$data;
  variables: modelGeneration3DModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportedModes",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ModelGeneration3DModelInfo",
    "kind": "LinkedField",
    "name": "modelGeneration3DModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPromptLength",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelGeneration3DParameterInfo",
        "kind": "LinkedField",
        "name": "supportedParameters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowedValues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxValue",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "modelGeneration3DModelsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "modelGeneration3DModelsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f844dbcd3a19dc8d012ecc6e1e53a998",
    "id": null,
    "metadata": {},
    "name": "modelGeneration3DModelsQuery",
    "operationKind": "query",
    "text": "query modelGeneration3DModelsQuery {\n  modelGeneration3DModels {\n    serviceID\n    serviceIDs\n    model\n    maxPromptLength\n    supportedModes\n    supportedParameters {\n      name\n      type\n      supportedModes\n      isRequired\n      defaultValue\n      allowedValues\n      minValue\n      maxValue\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c5b721dba0d555a74f44868a61adfe5";

export default node;
